import { Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { EmpresaService } from '../../../services/empresa.service';

@Component({
  selector: 'app-modal-crear',
  imports: [ReactiveFormsModule],
  templateUrl: './modal-crear.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./modal-crear.component.css'],
})
export class ModalCrearComponent {
  private empresaService = inject(EmpresaService);
  modal = input.required<any>();

  createSuccess = output<void>();
  createError = output<string>();

  // Evento para emitir los datos al componente padre
  // onSave = output<{
  //   ruc: string;
  //   nombre: string;
  //   email: string;
  //   contra: string;
  //   vencimiento: Date;
  // }>();

  private formBuilder = inject(FormBuilder);
  formCrear = this.formBuilder.group({
    ruc: [
      '',
      [Validators.required, Validators.minLength(11), Validators.maxLength(11)],
    ],
    nombre: ['', [Validators.required, Validators.minLength(1)]],
    email: ['', [Validators.required, Validators.email]],
    vencimiento: ['', Validators.required],
    sucursal_nombre: [
      'Sucursal Principal',
      [Validators.required, Validators.minLength(3)],
    ],
    sucursal_codigo: [
      'PRINCIPAL',
      [Validators.required, Validators.minLength(3)],
    ],
    contra: [
      '',
      [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(
          /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).*$/,
        ),
      ],
    ],
  });

  saveChanges() {
    const formData = this.formCrear.value;

    this.empresaService
      .createEmpresa({
        ruc: formData.ruc || '',
        nombre: formData.nombre || '',
        email: formData.email || '',
        vencimiento: formData.vencimiento || '',
        contra: formData.contra || '',
        sucursal: {
          nombre: formData.sucursal_nombre || 'Sucursal Principal',
          codigo: formData.sucursal_codigo || 'PRINCIPAL',
        },
      })
      .subscribe({
        next: (response) => {
          //console.log('Empresa creada exitosamente:', response);
          this.createSuccess.emit();
          this.modal().close();
          this.formCrear.reset();
        },
        error: (error) => {
          // Debug
          // console.error('Error al crear empresa:', error);
          this.createError.emit(error.message || 'Error');
        },
      });
  }
}
